module.exports = __webpack_public_path__ + "assets/GoldPsi.20fd61a22f1468cd051757a090928b53.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x-gold/GoldPsi.png
// module id = 772
// module chunks = 0